export default "__VITE_ASSET__CDtHUoNE__"